import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const paymentMethodService = {};

paymentMethodService.getPaymentMethodList = params => {
  const columnFilter = params.columnFilter || {};
  return fetchV2({
    url: `${env.API_MSP}/payment-methods`,
    method: "GET",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort,
      keywords: params.keywords,
      expand: params.expand,
    },
  });
};

paymentMethodService.createPaymentMethod = data => {
  return fetchV2({
    url: `${env.API_MSP}/payment-methods`,
    method: "POST",
    data,
  });
};

paymentMethodService.updatePaymentMethod = ({ id, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/payment-methods/${id}`,
    method: "PUT",
    data,
  });
};

paymentMethodService.updateStatusPaymentMethod = ({ id, record_status }) => {
  return fetchV2({
    url: `${env.API_MSP}/payment-methods/${id}`,
    method: "PUT",
    data: {
      record_status,
    },
  });
};

export default paymentMethodService;
